// src/components/Loader.js
import React from 'react';
import { useTranslation } from "react-i18next";
import { APP_NAME } from '../../constant/constant';
import { LOGO_SRC, LoaderDots } from './Loader';

// Fullscreen Loader Component
const Loding_compo = () => {
  const { t } = useTranslation();

  return (
    <div className="splash-screen" role="status" aria-label={t('common.loading')}>
      <img className="loader-logo" src={LOGO_SRC} alt={`${APP_NAME} logo`} />
      <LoaderDots />
      <p className="splash-text">{t('loader.loading')}</p>
      <p className="splash-version">{t('loader.appVersion', { version: '3.0' })}</p>
    </div>
  );
};

export default Loding_compo;
